module.exports = __webpack_public_path__ + "img/00003.cb61fa10.webp";